import { Feedback } from './feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class InCorrectFeedback extends Feedback {
  public static fromDto(dto: any): InCorrectFeedback {
    const feedback: InCorrectFeedback = new InCorrectFeedback();
    Feedback.mapBaseProperties(feedback, dto);
    return feedback;
  }
}
